import { ProductPriceScaleType } from '@iota/inh-core-v1-management-client';
import { ProductPriceScaleType as LegacyProductPriceScaleType } from '@iota/iota-management-portal-v4-client';

// Must cover every scale type of both clients; a missing label breaks the build.
const productPriceScaleTypeLabels: { [key in ProductPriceScaleType | LegacyProductPriceScaleType]: string } = {
    AGE_AT_END_OF_CALENDAR_YEAR: $localize`Age at end of calendar year`,
    UNKNOWN: $localize`Unknown type`
};

export const ProductPriceScaleTypeLabels = new Map(Object.entries(productPriceScaleTypeLabels));

// UNKNOWN is a backend fallback and must never be selectable.
export const SelectableProductPriceScaleTypes: ProductPriceScaleType[] = Object.values(ProductPriceScaleType).filter(
    (type) => type !== ProductPriceScaleType.UNKNOWN
);

export interface ScaleTypeOption {
    value: ProductPriceScaleType;
    label: string;
    selectable: boolean;
}

// A stored, non-selectable type (e.g. UNKNOWN) is appended as a disabled option so its label still shows.
export function buildScaleTypeOptions(storedScaleType?: ProductPriceScaleType): ScaleTypeOption[] {
    const options: ScaleTypeOption[] = SelectableProductPriceScaleTypes.map((scaleType) => ({
        value: scaleType,
        label: ProductPriceScaleTypeLabels.get(scaleType),
        selectable: true
    }));

    if (!!storedScaleType && !options.some((option) => option.value === storedScaleType)) {
        options.push({ value: storedScaleType, label: ProductPriceScaleTypeLabels.get(storedScaleType), selectable: false });
    }

    return options;
}
